import React, { useState, useEffect } from "react";
import { List, Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import http from "../../../../helpers/http";
import axios from "axios";
import { DragHandle } from "../../../../components/DragHandle";

const Ordering = ({
  isOpen,
  onClose,
  datas,
  apiEndpoint,
  successMessage,
  onUpdate,
}) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDatalist(datas);
  }, [datas]);

  const handleOrder = async (updatedData) => {
    setLoading(true);
    try {
      const finalData = updatedData.map((item, index) => ({
        id: item._id,
        sort_order: index,
      }));

      const response = await axios.post(apiEndpoint, finalData, {
        withCredentials: true,
      });

      if (response.status >= 200 && response.status < 300) {
        notification.success({
          message: successMessage || "Order updated successfully",
        });

        // Update parent list
        onUpdate(updatedData);

        onClose();
      }
    } catch (error) {
      notification.error({
        message: "Failed to update order",
      });
      console.error("Error updating order:", error.response || error.message);
    }
    setLoading(false);
  };

  return (
    <Modal
      title="Ordering"
      open={isOpen}
      onOk={() => handleOrder(datalist)}
      okText="Update"
      confirmLoading={loading}
      onCancel={onClose}
    >
      <DragDropContext
        onDragEnd={(param) => {
          const srcIndex = param.source.index;
          const destIndex = param.destination?.index;
          if (destIndex !== undefined) {
            let reordered = [...datalist];
            reordered.splice(destIndex, 0, reordered.splice(srcIndex, 1)[0]);
            setDatalist(reordered);
          }
        }}
      >
        <Droppable droppableId="order-list">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflow: "auto" }}
            >
              <List
                bordered
                dataSource={datalist}
                renderItem={(item, idx) => (
                  <Draggable key={item._id} draggableId={item._id} index={idx}>
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef}>
                        <List.Item
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            boxShadow: snapshot.isDragging
                              ? "0 0 .4rem #666"
                              : "none",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span>{item.title}</span>
                          <DragHandle {...provided.dragHandleProps} />
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default Ordering;
